import React, {Component} from 'react';
import { Field } from 'formik';

class Radio extends Component {

    render() {
        const { label, name, modifiers, form, value, ...rest } = this.props;

        const id= `${name}-${value}`;
        let className = 'radio';
        
        if (modifiers) modifiers.forEach(m => className+= ` radio--${m}`);

        // If using Formik, use Field component (has all the bindings)
        const FieldTag = form ? Field : 'input';

        return (
            <div className={className}>
                <FieldTag 
                    id={id}
                    name={name}
                    value={value}
                    type={`radio`}
                    className={`radio__input`}
                    {...rest}
                />
                <label 
                    className={`radio__label`}
                    htmlFor={id}
                >
                    <span className={`radio__icon`}></span>
                    { label ? label.text : '' }
                </label> 
            </div>
        );
    }
}

export { Radio };